import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _sortBy from "lodash/sortBy";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CONTENT_PREVIEW_PARAMETER, convertAssetToMedia, convertEmbedVideoToMedia, convertSeoMetaResponseToSeoMeta, retrieveCards, retrieveColorLogos, retrieveEmbeddedVideos } from './util';
var URL_PATH = "/content/entries/landingPageAbmPersonal";
export var fetchAllAbmPersonalPages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(client, options) {
    var url, response, transformedResponse;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = process.env.ENVIRONMENT === "staging" ? "".concat(URL_PATH, "?").concat(CONTENT_PREVIEW_PARAMETER, "=true") : URL_PATH;
            _context4.next = 3;
            return client.get(url, options);

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(templatePage) {
                var resources, featureBoxSectionBoxes, featureBoxes, profileCardsResponseArray, profileCards, accordionsSection, accordions, logoCarousel;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return retrieveCards(client, templatePage.resources);

                      case 2:
                        resources = _context3.sent;
                        featureBoxSectionBoxes = (templatePage === null || templatePage === void 0 ? void 0 : templatePage.featureBoxesFeatureBoxSection) || [];
                        _context3.next = 6;
                        return Promise.all(featureBoxSectionBoxes.map( /*#__PURE__*/function () {
                          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(featureBox) {
                            var isVideo, featured, resp;
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    isVideo = _get(featureBox, "fields.featured.sys.type") === "ResourceLink";

                                    if (!isVideo) {
                                      _context.next = 8;
                                      break;
                                    }

                                    _context.next = 4;
                                    return retrieveEmbeddedVideos(client, [featureBox.fields.featured]);

                                  case 4:
                                    resp = _context.sent;
                                    featured = convertEmbedVideoToMedia(resp[0]);
                                    _context.next = 9;
                                    break;

                                  case 8:
                                    featured = convertAssetToMedia(featureBox.fields.featured);

                                  case 9:
                                    return _context.abrupt("return", {
                                      heading: _get(featureBox, "fields.heading", ""),
                                      body: _get(featureBox, "fields.body", ""),
                                      featured: featured
                                    });

                                  case 10:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));

                          return function (_x4) {
                            return _ref3.apply(this, arguments);
                          };
                        }()));

                      case 6:
                        featureBoxes = _context3.sent;
                        profileCardsResponseArray = (templatePage === null || templatePage === void 0 ? void 0 : templatePage.profileCards) || [];
                        _context3.next = 10;
                        return Promise.all(profileCardsResponseArray.map( /*#__PURE__*/function () {
                          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(profileCard) {
                            var isVideo, featured, resp;
                            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    isVideo = _get(profileCard, "fields.featured.sys.type") === "ResourceLink";

                                    if (!isVideo) {
                                      _context2.next = 8;
                                      break;
                                    }

                                    _context2.next = 4;
                                    return retrieveEmbeddedVideos(client, [profileCard.fields.featured]);

                                  case 4:
                                    resp = _context2.sent;
                                    featured = convertEmbedVideoToMedia(resp[0]);
                                    _context2.next = 9;
                                    break;

                                  case 8:
                                    featured = convertAssetToMedia(profileCard.fields.featured);

                                  case 9:
                                    return _context2.abrupt("return", {
                                      name: _get(profileCard, "fields.name", ""),
                                      title: _get(profileCard, "fields.title", ""),
                                      bio: _get(profileCard, "fields.bio", ""),
                                      featured: featured
                                    });

                                  case 10:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));

                          return function (_x5) {
                            return _ref4.apply(this, arguments);
                          };
                        }()));

                      case 10:
                        profileCards = _context3.sent;
                        accordionsSection = (templatePage === null || templatePage === void 0 ? void 0 : templatePage.accordionsSection) || [];
                        accordions = accordionsSection.map(function (accordion) {
                          return _get(accordion, "fields", {});
                        });

                        if (!templatePage.logoCarousel) {
                          _context3.next = 19;
                          break;
                        }

                        _context3.next = 16;
                        return retrieveColorLogos(client, templatePage.logoCarousel);

                      case 16:
                        _context3.t0 = _context3.sent;
                        _context3.next = 20;
                        break;

                      case 19:
                        _context3.t0 = undefined;

                      case 20:
                        logoCarousel = _context3.t0;
                        return _context3.abrupt("return", _objectSpread(_objectSpread({}, templatePage), {}, {
                          companyName: _get(templatePage, "companyName", ""),
                          hero: {
                            image: convertAssetToMedia(templatePage.heroImage),
                            heading: _get(templatePage, "heroHeading", ""),
                            description: _get(templatePage, "heroDescription", ""),
                            companyLogo: convertAssetToMedia(templatePage.heroCompanyLogo),
                            logoCarousel: logoCarousel
                          },
                          section1: {
                            heading: _get(templatePage, "headingSection", ""),
                            description: _get(templatePage, "descriptionSection", ""),
                            image: convertAssetToMedia(templatePage.imageSection),
                            accordions: accordions,
                            featureBoxSection: {
                              featureBox1: featureBoxes[0],
                              featureBox2: featureBoxes[1]
                            },
                            profileCardSection: {
                              profileCard1: profileCards[0],
                              profileCard2: profileCards[1]
                            }
                          },
                          section2: {
                            callToActionHeading: _get(templatePage, "callToActionHeadingResourcesSection", ""),
                            resources: resources
                          },
                          seo: convertSeoMetaResponseToSeoMeta(_get(templatePage, "seo.fields", {})),
                          demoUtms: _get(templatePage, "demoUtms", "")
                        }));

                      case 22:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context4.sent;
            return _context4.abrupt("return", _sortBy(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchAllAbmPersonalPages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchAbmPersonalPage = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
    var client, options, slug, templatePages, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = _ref5.client, options = _ref5.options, slug = _ref5.slug;
            _context5.next = 3;
            return fetchAllAbmPersonalPages(client, options);

          case 3:
            templatePages = _context5.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context5.abrupt("return", data);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchAbmPersonalPage(_x6) {
    return _ref6.apply(this, arguments);
  };
}();